<div class="container-fluid background-transparent pt-0">
  <app-trial-license-warning></app-trial-license-warning>
  <lib-campaigns></lib-campaigns>
</div>

<div class="content-inner background-section">
  <div class="title-bar background-transparent">
    <a class="back-button mt-2 mb-4" (click)="emitData({key: 'back'})">
      <img src="assets/ph-bhp-layout/svg/back.svg" class="svg mr-2 ml-4 back-button">
      {{ translationKeys.SOPObservation.Back | translate }}
    </a>
    <div class="container-fluid d-md-flex justify-content-between background-transparent">
      <h2 class="page-title"> {{ 'CHECK.EVALUATION.INDIVIDUAL_AUDIT_DATA_OVERVIEW' | translate }} </h2>
      <div>
        <lib-php-bhp-check-chart-export #exportTag [gridData]="gridData" [fields]="fields" [results]="results"
          [filters]="filters ? filters.toArray() : []" [select]="'individualAuditDataOverview'"
          (childData)="emitData($event)" class="col p-0" [fileName]="pageTitle" [appName]="appName"
          [clickImageBtn]="clickImageBtn" [clickExcelBtn]="clickExcelBtn" [clickPdfBtn]="clickPdfBtn"
          [userData]="userData" (resetClickBtn)="resetExportAs($event)">
        </lib-php-bhp-check-chart-export>
      </div>
    </div>
  </div>

  <div>
    <div class="evaluation-section container-fluid reportFilter">
      <div class="row mt-4">
        <div class="col-12">
          <div class="form-group multiselect-container">
            <div class="multiselect-top d-flex justify-content-between">
              <label>{{ "CHECK.EVALUATION.QUESTIONNAIRES" | translate }}</label>
              <button class="multiselect-clear" (click)="resetQuestionnaireFilter()">
                <img src="assets/icons/closeOutlined.svg" />
              </button>
            </div>
            <div class="multiselect-div">
              <kendo-multiselect #multiselect [data]="questionnaires" [(ngModel)]="selectedQuestionnaires"
                [textField]="'questionnaireName'" (valueChange)="onMultiselectChange($event)" [valueField]="'id'"
                [autoClose]="false" placeholder="{{ 'CHECK.EVALUATION.ALL_QUESTIONNAIRES' | translate }}">
                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                  {{ dataItem.questionnaireName | labelSanitizer}}
                </ng-template>
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                  <div class="questionnaire-item">
                    <input type="checkbox" class="k-checkbox">
                    <span class="questionnaire-name">{{ dataItem.questionnaireName | labelSanitizer }}</span>
                    <span class="questionnaire-institution">{{ dataItem.institutionName | labelSanitizer }}</span>
                  </div>
                </ng-template>
              </kendo-multiselect>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col my-3 d-flex justify-content-end">
          <button class="btn-link-reset" (click)="resetFilters()" *ngIf=isDesktop>{{ 'EVALUATION.RESET_FILTERS' |
            translate }}</button>
        </div>
      </div>

      <ng-container *ngFor="let filterIndex of filterIndices; let i = index; trackBy: trackLoop">
        <lib-ph-bhp-filter #filter [filterIndex]="i" [userData]="appConfig.userData" [isDesktop]='isDesktop'
          [shouldShowRemoveButton]="filterIndex > 0" [evaluationLoaded]="evaluationLoaded"
          (filterRemoved)="onFilterRemoved(filterIndex)" [showProAndSubPro]="false" [isMultiselectReport]="false"
          *ngIf="filterIndex === 0 || (filterIndex > 0 && showCompareCard)" (filterSaved)="onFilterSaved()"
          [userHasFilter]="userHasFilter"></lib-ph-bhp-filter>
      </ng-container>

      <div class="row">
        <div class="col my-3 d-flex justify-content-between">
          <div (click)="showDeleteSelectionModal()" class="btn-delete-selection"
            [ngClass]="!userHasFilter ? 'disabled-delete-selection' : ''">
            <img class="dropdown-arrow mr-2"
              src="{{ !userHasFilter ? 'assets/icons/trashDarkOutlined-disabled.svg' : 'assets/icons/trashDarkOutlined.svg' }}" />
            <label class="selection-label">{{ 'EVALUATION.DELETE_SELECTION' | translate }}</label>
          </div>

          <div class="dropdown dropdown-bhp-export">
            <div class="dropdown-container-input" [ngClass]="!userHasFilter ? 'disabled' : ''" data-toggle="dropdown"
              aria-expanded="false">
              <div class="d-flex align-items-center">
                <img class="dropdown-arrow mr-2"
                  src="{{ !userHasFilter ? 'assets/icons/downloadDarkOutlined-disabled.svg' : 'assets/icons/downloadDarkOutlined.svg' }}" />
                <label [ngClass]="!userHasFilter ? 'disabled-export' : ''">{{ 'EVALUATION.EXPORT' | translate }}</label>
              </div>
              <img class="dropdown-arrow"
                src="{{ !userHasFilter ? 'assets/icons/arrowDropdownOutlined-disabled.svg' : 'assets/icons/arrowDropdownOutlined.svg' }}" />
            </div>

            <ul class="dropdown-menu">
              <li class="dropdown-item" *ngIf="results" (click)="excelDownload()">{{ 'GENERAL.EXCEL' | translate }}</li>
            </ul>
          </div>
        </div>
      </div>

      <div *ngIf="userHasFilter">
        <div class="row">
          <h1 class="section-title col-md-6"> {{ "CHECK.EVALUATION.INDIVIDUAL_AUDIT_DATA_OVERVIEW" | translate }} </h1>
          <div [ngClass]="!noDataFound ? 'active-refresh' : 'inactive-refresh'"
            class="justify-content-end col-md-6 refresh-box" (click)="onRefreshClick(noDataFound)">
            <img *ngIf="!noDataFound" src="assets/ph-bhp-evaluation/icon-refresh-active.svg" />
            <img *ngIf="noDataFound" src="assets/ph-bhp-evaluation/icon-refresh-inactive.svg" />
            <span>{{ 'CONFIGURE.FILTERS.REFRESH' | translate }}</span>
          </div>

          <div class="col-12 gridContainer" *ngIf="userHasFilter">
            <bd-light-table #gridTable [gridData]="gridData || []" [pageInfo]="pageInfo" [fields]="fields"
              *ngIf="userHasFilter" [actions]="actionItems" [isSelectable]="isSelectable"
              [isEvaluationTable]="isEvaluationTable"></bd-light-table>
            <div class="no-data-box" *ngIf="!userHasFilter">
              <span class="no-data-text">{{ 'CONFIGURE.FILTERS.NO_FILTER_FOUND' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<lib-download-modal></lib-download-modal>